import React, { useCallback, FunctionComponent } from 'react';

import { InfoBox, Spacing, SpacingName } from '@doveit/lego';
import SelectableItem, { SelectableItemProps } from '../selectable-item/SelectableItem';

import * as styles from './SelectableList.style';

export interface SelectableListProps {
  title?: string,
  items: SelectableItemProps[],
  activeItem?: string | number,
  onItemClick: (item: SelectableItemProps) => void,
  noItemsMessage?: string,
}

const DEFAULT_NO_ITEMS_MESSAGE = 'Non ci sono dati';

const SelectableList: FunctionComponent<SelectableListProps> = ({
  title,
  items,
  activeItem,
  noItemsMessage,
  onItemClick,
}) => {
  const handleClick = useCallback(
    (item) => () => {
      if (onItemClick) {
        onItemClick(item);
      }
    },
    [onItemClick],
  );
  return (
    <div>
      {title && (
        <div
          css={styles.title}
          data-ref="selectable-list-title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      {items.length === 0 && (
        <Spacing margin={[0, SpacingName.SMALL]}>
          <InfoBox message={noItemsMessage || DEFAULT_NO_ITEMS_MESSAGE} />
        </Spacing>
      )}
      {items.length > 0 && (
        <ul>
          {items.map((item) => (
            <li key={item.id}>
              <SelectableItem
                {...item}
                active={activeItem !== undefined && item.id === activeItem}
                onItemClick={handleClick(item)}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SelectableList;
